<main>
    <div class="container main">
        <div class="row">
            <div class="col">
                <form [formGroup]="form" (ngSubmit)="cadastrar()">
                    <h1 class="mt-3">Cadastro de cliente</h1>
                    <div class="row">
                        <div class="form col-md-6">
                            <label class="label-input" for="">
                                <span>Nome do cliente:</span>
                                <input formControlName="vc_nome" class="input" type="text" name="nome-cliente"
                                    id="nome-cliente">
                                <ng-container *ngIf="form.controls.vc_nome.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_nome.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                        <div class=" form col-md-3">
                            <label class="label-input" for="">
                                <span>CNPJ:</span>
                                <input formControlName="vc_cnpj" class="input" type="text" name="cnpj" id="cnpj"
                                    mask="00.000.000/0000-00">
                                <ng-container *ngIf="form.controls.vc_cnpj.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_cnpj.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                        <div class="col-md-3">
                            <label>
                                <span>Produtos:</span>
                                <mat-select formControlName="ar_produtos" class="input" multiple>
                                    <div *ngFor="let produto of produtos">
                                        <mat-option [value]="produto.sr_id">{{produto.vc_nome}}</mat-option>
                                    </div>
                                </mat-select>

                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form col-md-6">
                            <label class="label-input" for="">
                                <span>Nome responsável:</span>
                                <input formControlName="vc_nome_responsavel" class="input" type="text" name="nome-resp"
                                    id="nome-resp">
                                <ng-container *ngIf="form.controls.vc_nome_responsavel.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_nome_responsavel.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                        <div class="form col-md-6">
                            <label class="label-input" for="">
                                <span>Email do responsável:</span>
                                <input formControlName="vc_email_responsavel" class="input" type="text"
                                    name="email-resp" id="email-resp">
                                <ng-container *ngIf="form.controls.vc_email_responsavel.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_email_responsavel.errors?.required">
                                        Campo obrigatório *
                                    </p>
                                    <p class="msg-erro" *ngIf="form.controls.vc_email_responsavel.errors?.email">
                                        E-mail inválido*
                                    </p>
                                </ng-container>
                            </label>
                        </div>

                    </div>
                    <span>Endereço</span>
                    <div class="row">
                        <div class="form col-md-9">
                            <label class="label-input" for="">
                                <span>Logradouro:</span>
                                <input formControlName="vc_endereco" class="input" type="text" name="endereco"
                                    id="endereco">
                                <ng-container *ngIf="form.controls.vc_endereco.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_endereco.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                        <div class="form col-md-3">
                            <label class="label-input" for="">
                                <span>Complemento:</span>
                                <input formControlName="vc_complemento" class="input" type="text" name="complemento"
                                    id="complemento">
                                <ng-container *ngIf="form.controls.vc_complemento.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_complemento.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form col-md-5">
                            <label class="label-input" for="">
                                <span>Cidade:</span>
                                <input formControlName="vc_cidade" class="input" type="text" name="cidade" id="cidade">
                                <ng-container *ngIf="form.controls.vc_cidade.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_cidade.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                        <div class="form col-md-2">
                            <label class="label-input" for="">
                                <span>Estado:</span>
                                <input formControlName="vc_estado" class="input" type="text" name="estado" id="estado">
                                <ng-container *ngIf="form.controls.vc_estado.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_estado.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                        <div class="form col-md-2">
                            <label class="label-input" for="">
                                <span>País:</span>
                                <input formControlName="vc_pais" class="input" type="text" name="pais" id="pais">
                                <ng-container *ngIf="form.controls.vc_pais.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_pais.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                        <div class="form col-md-3">
                            <label class="label-input" for="">
                                <span>CEP:</span>
                                <input formControlName="vc_codigo_postal" class="input" type="text" name="cep" id="cep"
                                    mask="00000-000">
                                <ng-container *ngIf="form.controls.vc_codigo_postal.touched">
                                    <p class="msg-erro" *ngIf="form.controls.vc_codigo_postal.errors">
                                        Campo obrigatório *
                                    </p>
                                </ng-container>
                            </label>
                        </div>
                        <div class="form col-md-12">
                            <span>Localização:</span>
                            <div id="map" class='notHidden'></div>
                        </div>
                    </div>
                    <div id="buttons">
                        <button id="btn-sucesso" class="btn btn-sm btn-success" type="submit">Cadastrar</button>
                        <button id="btn-cancelar" (click)="cancel()" class="btn btn-sm btn-danger"
                            type="btn">Cancelar</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
    <div class="load d-flex justify-content-center" *ngIf="load">
        <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
        </mat-progress-spinner>
    </div>
</main>